export default "__VITE_ASSET__CkKNfKZY__"